export * from './SyntheticDOM';